/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useMemo } from 'react';

import { useAppConfig } from '@airasia-rn/ui';
import { useSuperAppContext } from '@airasia-rn/ui/context';

import { useFlightConfig } from '../config/FlightConfigProvider';
import { LowFareApiService } from '../services/lowFareApiService';

export function useLowFareApiService() {
  const appConfig = useAppConfig();
  const userAppContext = useSuperAppContext();
  const {
    config: { geoId: flightConfigGeoId },
  } = useFlightConfig();

  const geoId =
    flightConfigGeoId || userAppContext.geoId || appConfig.config.geoId || 'MY';
  return useMemo(() => {
    return new LowFareApiService(appConfig.config.env, geoId);
  }, [appConfig.config.env, geoId]);
}
